export default (options) => {
  // default options
  const defaultOptions = {
    container: options.element || document.getElementsByClassName('ss-audio-player')[0],
    autoplay: false,
    mutex: true,
    preload: 'metadata',
    volume: 0.7,
    storageName: 'testv__audio__player__setting'
  }

  for (const defaultKey in defaultOptions) {
    // eslint-disable-next-line no-prototype-builtins
    if (defaultOptions.hasOwnProperty(defaultKey) && !options.hasOwnProperty(defaultKey)) {
      options[defaultKey] = defaultOptions[defaultKey]
    }
  }

  options.audio.name = options.audio.name || options.audio.title || 'Audio name'
  options.audio.artist = options.audio.artist || options.audio.author || 'Audio artist'
  options.audio.cover = options.audio.cover || options.audio.pic
  options.audio.type = options.audio.type || 'normal'

  return options
}
